import React, {Component} from 'react';
import {withRouter,Link,NavLink} from 'react-router-dom';
import { Elements } from 'react-stripe-elements';
import Responsive from 'react-responsive';
import GateFeeProcessing from './GateFeeProcessing';
import Api from '../../../utils/api';
import './GateFee.css';

class GateFee extends Component {
    constructor() {
        super();

        this.state = {
            selectedGenderId: null,
            showThankYou: false,
            firstName: '',
            lastName: '',
            phoneNumber: '',
            email: '',
            openPhoneConfirmModal: false,
            phoneCountry: '',
            planValue:  0,
            paymentType:'',
            modeStep:1,
            loadSubmitPayment:false,
            gateFeePaid:false,
            planLoadRecomm:false,
        }

        this.showThankYou = this.showThankYou.bind(this);
        this.closePhoneConfirmModal = this.closePhoneConfirmModal.bind(this);
        this.changeStepStep = this.changeStepStep.bind(this);

    }

    componentWillMount() {
        try {
            this.setState({planValue : this.props.location.state.planValue, paymentType: this.props.location.state.paymentType },()=>{
                this.fun_stepManager()
            });
        } catch (error) {
            this.setState({planValue : 0, paymentType: '' },()=>{
                this.fun_stepManager()
            });
        }
            
            // this.getAccountInfo();
           
            // var user_account_info = localStorage.getItem("user_account_info");
            // if(util.isJSON(user_account_info)){
            //    let user_account_infoJson = JSON.parse(user_account_info);
            //    const phoneCountry = util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1);
            //    this.setState({
            //     phoneCountry: util.transformationCountryNumber(user_account_infoJson.region ? user_account_infoJson.region.id : 1) 
            //    })
            //    localStorage.setItem("phoneCountry",phoneCountry);
            //    localStorage.setItem("phoneCountryNumber",user_account_infoJson.region ? user_account_infoJson.region.id : 1);
            // }
        }

    fun_stepManager(){
        const userId = localStorage.getItem("user_id");
        if (!userId) {
            this.props.history.push('/signin');
        } else {
            if (localStorage.getItem('temp_new_user_flag')) {
                localStorage.removeItem('temp_new_user_flag');
            }

           if(localStorage.getItem("planTier") == "5" || localStorage.getItem("planTier") == "4" ){
                if(this.state.paymentType == 'PLAN_WTO' || this.state.paymentType == 'UPSELL' ){
                    this.setState({modeStep : 1 });
                }else if(localStorage.getItem("gateFeePaid") == "true" || this.state.gateFeePaid == true){
                    this.setState({modeStep : 3 });
                }else{
                    this.setState({modeStep : 1 });
                }
            }else if(localStorage.getItem("planTier") == "1" ){
                if(this.state.paymentType == 'PLAN_WTO'){
                    this.setState({modeStep : 1 });
                }else{
                    if(window.location.pathname.includes("/recommendation-landing-thank")){
                        this.setState({modeStep : 3 });
                    }else{
                        this.props.history.push('/recommendations');
                    }
                }
            } else if(localStorage.getItem("gateFeePaid") == "true" || this.state.gateFeePaid == true){
                this.setState({modeStep : 3 });// 已经付了咨询费，直接看到步骤3
            }else{
                this.checkIfPaidGateFee();
            }
        }
    }


    componentDidMount() {
        document.documentElement.scrollTop = 0;
        try {
            this.setState({planValue : this.props.location.state.planValue });
        } catch (error) {
            this.setState({planValue : 0 });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevState.gateFeePaid != this.state.gateFeePaid){
            if(this.state.gateFeePaid == true && this.state.paymentType != 'PLAN_ONE' ){
                this.setState({modeStep : 3 });
            }
        }
    }

    checkIfPaidGateFee() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/user-flags/gate-fee-paid?user-id=' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        })
        .then((response) => response.json()).then(responseJson => {
            if (responseJson) {
                this.setState({ showThankYou: true,gateFeePaid: true});
                localStorage.setItem("gateFeePaid",true)
            }else{
                this.setState({gateFeePaid: false});
            }
        }).catch(function(err) {
            console.log("There was a problem checking payment status. Please try again.");
        });
    }

    formatPhoneNumber(phoneNumberString) {
        let cleaned = ('' + phoneNumberString).replace(/\D/g, '')
        if(this.state.phoneCountry == "UK"){
            return cleaned;
        }else{
            let match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3];
            }
        }
        return null;
    }

    //Get user name, email, and phone number
    getAccountInfo() {
        const userId = localStorage.getItem("user_id");
        fetch('/api/user-account-info/' + userId, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-auth-token': Api.auth_tokenManager()
            }
        }).then((response) => response.json()).then(responseJson => {
            this.setState({
                selectedGenderId: responseJson.gender && responseJson.gender.id,
                firstName: responseJson.firstName,
                lastName: responseJson.lastName,
                email: responseJson.email,
                phoneNumber: this.formatPhoneNumber(responseJson.phoneNumber),
                // phoneNumber: responseJson.phoneNumber,最简单的就是去除电话验证
            }, () => {
                this.directToLandingPage();
            });
        }).catch(function(err) {
            console.log("There is a problem to get the account info. Please try again.");
        });
    }

    
    changeStepStep(type) {
        if(type == "explorer"){
            this.setState({planLoadRecomm:true});
        }else{
            let modeStep = this.state.modeStep;
            modeStep++;
            if(modeStep == 2){
                this.setState({loadSubmitPayment:true,modeStep:0},()=>{
                    document.documentElement.scrollTop = 0;           
                    setTimeout(()=>{
                        this.setState({loadSubmitPayment:false,modeStep:modeStep})
                    },3000)
                })
            }else if(modeStep == 3){
                document.documentElement.scrollTop = 0;
                window.Calendly.initPopupWidget({url: 'https://calendly.com/helloavaconsults'});
                this.setState({modeStep:modeStep},()=>{
                    // window.open("https://calendly.com/helloavaconsults","_blank")
                })
                this.checkIfPaidGateFee();
            }else{
                document.documentElement.scrollTop = 0;
                this.setState({modeStep:modeStep})
            }
        }
        
    }

    fun_openCalendly(){
        window.Calendly.initPopupWidget({url: 'https://calendly.com/helloavaconsults'});
    }

    showThankYou() {
        this.setState({ showThankYou: true });
        this.setState({ openPhoneConfirmModal: false })
    }

    closePhoneConfirmModal() {
        this.setState({ openPhoneConfirmModal: false });
    }

    openPhoneConfirmUrl(){
        window.location.href = 'https://mailchi.mp/helloava/freeconsultation';
    }

    render() {
        return (
            <div className="publicView" style={{marginBottom:'100px'}}>
                <div className="plan-area-style gateFee-style" style={{ backgroundColor: '#ffff',textAlign:'center'}}>
                    
                    <div className="gate-fee-body">
                        <div className="gatefee-checkout-custom">
                            <div name="purchase-view" id="gate-fee" style={ this.state.modeStep == 1 ? {width:'100%',display:'block'} : {display:'none'} }>
                                <div style={{marginBottom: '14px'}} className="skin-type-hello-title">Complete your purchase</div>
                                <Elements>
                                    <GateFeeProcessing
                                        showThankYou={ this.showThankYou }
                                        showThankYouMessage={ this.state.showThankYou }
                                        firstName={ this.state.firstName }
                                        lastName={ this.state.lastName }
                                        phoneNumber={ this.state.phoneNumber }
                                        email={ this.state.email }
                                        planValue={this.state.planValue}
                                        paymentType = {this.state.paymentType}
                                        fun_changeStepStep = {this.changeStepStep}
                                    />
                                </Elements>
                            </div>
                        </div>
                    </div>

                    <div style={this.state.loadSubmitPayment ? {display:'block'}:{display:'none'} } className="load-submit-payment">Submitting payment . . . </div>
                    
                    <div className="plan-load-recomment" style={this.props.planLoadRecomm ? {display:'flex'}:{display:'none'}}>
                        <div className="plan-load-recomment-img">
                            <img src="../images/plan/large/loadingAnimation.gif"></img>
                        </div>
                        <p>Our algorithm is working its magic <br/> and putting together your product <br/> recommendations</p>
                    </div>
                    
                    <div name="scheduleConsultView" style={ this.state.modeStep == 2 ? {width:'100%',display:'block'} : {display:'none'} }>
                        <div className="skin-type-hello-title">We received your payment. <br/> Schedule your consult now</div>
                        <div className="scheduleConsultView-area">
                            <div className="scheduleConsultView-area-img">
                                <img src="/images/plan/large/kim.jpg"></img>
                            </div>
                            <div className="scheduleConsultView-right-text">
                                <Responsive maxWidth={ 767 }>
                                    <button onClick={this.changeStepStep} className="p-a-n-button gateFeff-submit-but">Schedule Your Consult </button>
                                </Responsive>

                                <h3 className="h3-title-consult">Here’s what happens next: </h3>
                                <div className="s-text-conten-area">
                                    <i className="serial-number-g">1</i>
                                    <ul className="s-area-text">
                                        <li className="s-area-text-title">Schedule your skin consult</li>
                                        <li className="s-area-text-conten">This is an opportunity for us to take a closer look at your skin and talk about your current routine before tailoring your recommendations</li>
                                    </ul>
                                </div>
                                <div className="s-text-conten-area">
                                    <i className="serial-number-g">2</i>
                                    <ul className="s-area-text">
                                        <li className="s-area-text-title">Receive your recommendations</li>
                                        <li className="s-area-text-conten">You will receive your recommendations via SMS right after your consultation.</li>
                                    </ul>
                                </div>
                                <Responsive minWidth={ 767 }>
                                    <button  onClick={this.changeStepStep} style={{marginLeft:0}} className="p-a-n-button gateFeff-submit-but">Schedule Your Consult </button>
                                </Responsive>
                            </div>
                        </div>
                    </div>

                    <div name="consultaion-view" style={ this.state.modeStep == 3 ? {width:'100%',display:'block'} : {display:'none'} }>
                        <div className="skin-type-hello-title">Get ready for your consultation</div>
                        <div className="scheduleConsultView-area" style={{alignItems:'flex-start'}}>
                            <div className="scheduleConsultView-area-img">
                                <img src="/images/plan/large/Getready.jpg"></img>
                            </div>
                            <div className="scheduleConsultView-right-text">
                                <div className="s-text-conten-area">
                                    <ul className="s-area-text mobile-s-area-text">
                                        <p className="s-area-text-title">Easy-breezy!</p>
                                        <Responsive minWidth={ 767 }>
                                            <li className="s-area-text-conten">Simply prepare a list of questions you want to ask and<br/>make sure you have a good connection during the<br/>consultation.</li>
                                        </Responsive>
                                        <Responsive maxWidth={ 767 }>
                                            <li className="s-area-text-conten">Simply prepare a list of questions you want to ask and make sure you have a good connection during the consultation.</li>
                                        </Responsive>
                                        <li>
                                            {
                                                localStorage.getItem("planTier") && localStorage.getItem("visited_recommendations") == "true" && localStorage.getItem("gateFeePaid") == "true"  && this.state.paymentType != 'UPSELL' ?
                                                <button onClick={()=>{ this.props.history.push('/recommendations'); }} className="p-a-n-button reschedule-but">Back to Recommendations</button>
                                                : <button onClick={()=>{ this.fun_openCalendly() }} className="p-a-n-button reschedule-but">Reschedule Your Consult</button>
                                            }
                                        </li>
                                    </ul>
                                    
                                </div>
                            </div>
                        </div>
                        <div name="meantime-zone" style={{marginTop:'60px'}}>
                            <Responsive minWidth={ 767 }>
                                <div className="skin-type-hello-title">In the meantime, check out…</div>
                            </Responsive>
                            <div style={{width:'100%',marginTop:'46px'}}>
                                <Responsive minWidth={ 767 }>
                                    <ul className="meantime-area-ul">
                                        <li>
                                            <NavLink to="/Blog">
                                                <img src="/images/plan/large/clientStories.png"></img>
                                                <span>Ava Academy</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <NavLink to="/survey-result">
                                                <img src="/images/plan/large/skinProfile.png"></img>
                                                <span>Skin profile</span>
                                            </NavLink>
                                        </li>
                                        <li>
                                            <a target="_blank" href="https://shop.helloava.co/?utm_source=webapp&utm_medium=packageselectedpg&utm_campaign=shop_ha">
                                                <img src="/images/plan/large/helloAvaVettedProducts.jpg"></img>
                                                <span>Pro vetted products</span>
                                            </a>
                                        </li>
                                    </ul>
                                </Responsive>
                                
                                <Responsive maxWidth={ 767 }>
                                    <ul className="meantime-area-ul">
                                        <li>
                                            <a target="_blank" href="https://shop.helloava.co/?utm_source=webapp&utm_medium=packageselectedpg&utm_campaign=shop_ha">
                                                <img src="/images/plan/large/helloAvaVettedProducts.jpg"></img>
                                                <span>Pro vetted products</span>
                                            </a>
                                        </li>
                                        <li>
                                            <NavLink to="/survey-result">
                                                <img src="/images/plan/large/skinProfile.png"></img>
                                                <span>Skin profile</span>
                                            </NavLink>
                                        </li>
                                    </ul>
                                    <div className="mobile-clientStories-img">
                                        <NavLink to="/Blog">
                                            <img src="/images/plan/large/clientStories.png"></img>
                                            <span>Ava Academy</span>
                                        </NavLink>
                                    </div>  
                                </Responsive>
                            </div>
                            <p className="bottom-stay-tips">Stay in touch for daily skincare tips</p>
                            <p className="bottom-incon-face-ins">
                                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/HelloAVAbeauty/"> <img className="feacbook-img" src="/images/plan/large/facebook.svg"/></a>
                                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/helloavabeauty/"> <img className="Instagram-img" src="/images/plan/large/Instagram.svg"/> </a>
                            </p>
                        </div>
                    </div>
                </div>
                 {/* <!-- Your Chat Plugin code --> */}
                 {/* <div className="fb-customerchat"
                    attribution="install_email"
                    page_id="1809451302622337"
                    theme_color="#FFAD94"
                    title = 'Chat with a real human'
                    logged_in_greeting="Got questions? "
                    logged_out_greeting="Got questions? ">
                </div> */}
            </div>
        );
    }
}

export default withRouter(GateFee);



// WEBPACK FOOTER //
// ./src/views/AA/gateFee/GateFee.js